import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { premiumStoresListQueries } from '@/services/premiumStores/premiumStores.queries';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useDeletePremiumStoreInfo = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('deletePremiumStoreInfo', {
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({ queryKey: premiumStoresListQueries.all('A') });
      toast.success(data.message);
      await revalidate(['editorRecommendedStores']);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutate: mutateAsync };
};
